import {
  TEDLRFakturaAttestAttestTypEnum,
  TEDLRFakturaAttestSTATUSEnum,
  TEDLRLeverantorfakturaMOMSHANTERINGEnum,
} from '../../../../../../../../globalQueryTypes';
import { FormUpdateAssociatonType } from '../../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormValueUtils';
import { LRSysOptionsQuery_db_SYSMoms_All } from '../../../Queries/LRSysOptionQuery/_QueryTypes/LRSysOptionsQuery';
import { getKonteringRadtyp } from '../../../Utils/FakturadelUtils';
import { GetKostnadsBeloppFormValueType } from '../../FakturaDelContextManager/FakturaDelContextManager';
import {
  getIngaendeMoms,
  getUtlandskAvdrag,
  roundToTwoDecimals,
} from '../../Kontering/Utils/KonteringUtils';
import { INewKonteringValues } from '../FakturaAttestKonteringHistoryModal';
import {
  GetKonteringHistory_node_TEDLRLeverantor__Associations_Fakturor_Connection_edges,
  GetKonteringHistory_node_TEDLRLeverantor__Associations_Fakturor_Connection_edges_node,
} from '../Queries/_QueryTypes/GetKonteringHistory';

/**
 *
 * @param originKontering Ursprungliga konteringsförslaget
 * @param length Antal valda konteringsförslag
 * @returns Det nya rubriksbeloppet
 */
export const getCalculatedValue = (
  radtyp: number | null,
  debet: number,
  kredit: number,
  beloppExMoms: number | null,
  beloppIncMoms: number | null,
  length: number
): string => {
  switch (radtyp) {
    case null:
    case 0:
    case 2:
      return `${roundToTwoDecimals(
        Math.abs(Math.round((debet * 100) / length) / 100) -
          Math.abs(Math.round((kredit * 100) / length) / 100)
      )}`;
    case 1:
    case 5:
    case 6:
      return `${roundToTwoDecimals(beloppExMoms ?? 0)}`;

    case 3:
    case 4:
      return `${roundToTwoDecimals(beloppIncMoms ?? 0)}`;

    default:
      return `${roundToTwoDecimals(
        Math.abs(Math.round((debet * 100) / length) / 100) -
          Math.abs(Math.round((kredit * 100) / length) / 100)
      )}`;
  }
};
export const getCalculatedValueObject = (
  radtyp: number | null,
  debet: number,
  kredit: number,
  ingMoms: number,
  utlMoms: number,
  length: number
): {
  DEBET: number;
  KREDIT: number;
  BELOPP_INKL_MOMS?: number;
  BELOPP_EXKL_MOMS?: number;
} => {
  const beloppValue = roundToTwoDecimals(
    Math.abs(Math.round((debet * 100) / length) / 100) -
      Math.abs(Math.round((kredit * 100) / length) / 100)
  );

  switch (radtyp) {
    case null:
    case 0:
    case 2:
      return { DEBET: debet, KREDIT: kredit };
    case 1:
    case 5:
    case 6:
      return {
        DEBET: debet,
        KREDIT: kredit,
        BELOPP_EXKL_MOMS: beloppValue - utlMoms,
      };

    case 3:
    case 4:
      return {
        DEBET: debet,
        KREDIT: kredit,
        BELOPP_INKL_MOMS: beloppValue + ingMoms,
      };

    default:
      return { DEBET: debet, KREDIT: kredit };
  }
};

export const createBills = (
  bill: GetKonteringHistory_node_TEDLRLeverantor__Associations_Fakturor_Connection_edges
) => {
  return {
    ...bill?.node,
    _Associations: {
      ...bill?.node?._Associations,
      Konteringsforslag_All:
        bill?.node?._Associations?.Konteringsforslag_All?.filter(
          kontering =>
            kontering._Associations?.Fakturaattest?.AttestTyp ===
              TEDLRFakturaAttestAttestTypEnum.BESLUTSATTEST &&
            kontering._Associations?.Fakturaattest?.STATUS ===
              TEDLRFakturaAttestSTATUSEnum.ATTESTERAD
        ),
    },
  } as GetKonteringHistory_node_TEDLRLeverantor__Associations_Fakturor_Connection_edges_node;
};

export const additionalInfoResetValues = {
  AR_BENAMNING: null,
  AR_AVSKR_TID: null,
  AR_INV_DATUM: null,
  AR_TILLGANG_BEN: null,
  AR_KOMMENTAR: null,
  AR_NY: null,
  AR_FI_BENAMNING: null,
  AR_FI_DATUM: null,
  AR_FI_KOMMENTAR: null,
  FI_REGISTRERAS: null,
};

export const additionalInfoResetRefValues = {
  AvskrKontodel1_Ref: null,
  AvskrKontodel2_Ref: null,
  AvskrKontodel3_Ref: null,
  AvskrKontodel4_Ref: null,
  AvskrKontodel5_Ref: null,
  AvskrKontodel6_Ref: null,
  AvskrKontodel7_Ref: null,
  AvskrKontodel8_Ref: null,
  AvskrKontodel9_Ref: null,
  AvskrKontodel10_Ref: null,
  Komponenttyp_Ref: null,
  Kontodel1_Ref: null,
  Kontodel2_Ref: null,
  Kontodel3_Ref: null,
  Kontodel4_Ref: null,
  Kontodel5_Ref: null,
  Kontodel6_Ref: null,
  Kontodel7_Ref: null,
  Kontodel8_Ref: null,
  Kontodel9_Ref: null,
  Omrade_Ref: null,
  FIOmrade_Ref: null,
  Tillgang_Ref: null,
  FITillgang_Ref: null,
  FIKategori_Ref: null,
  FIByggnad_Ref: null,
};

export const getKonteringsforslagValues = (
  newValuesID: string,
  newSortNumber: number,
  radtypDefault: number,
  selectedMomskontodelsDefOrdningsNr: number,
  momsKontodelID: string | undefined,
  momsHantering: TEDLRLeverantorfakturaMOMSHANTERINGEnum | null,
  registreratMomsBelopp: number,
  ingMomsSats: number | null,
  konteringID: string | undefined,
  debet: number | undefined,
  kredit: number | undefined,
  beloppInklMoms: number,
  beloppExklMoms: number,
  utlMomsSats: number | undefined | null,
  utlMoms: number | undefined,
  ingMomsMall: number | null,
  utlLevMomsSats: number | null,
  fakturaID: string,
  kodplanID: string,
  bokfDatum: Date,
  preSelectedMomssats: LRSysOptionsQuery_db_SYSMoms_All | undefined,
  setNewBeloppChange: (id: string | null) => void,
  getKostnadsBeloppFormValue: GetKostnadsBeloppFormValueType,
  isNewSelectedKontodelMomspliktig: (
    kodplanId: string,
    ordningsNr: number,
    kontodelId: string,
    bokfDate: Date,
    useObseleteGetKontodelByKontodel?: boolean | undefined
  ) => boolean,
  getAvdragsratt: (
    kodplanId: string,
    ordningsNr: number,
    kontodelId: string,
    bokfDate: Date,
    radtyp: number,
    useObseleteGetKontodelByKontodel?: boolean | undefined
  ) => number
) => {
  const associatedObject: FormUpdateAssociatonType[] = [];
  let values: INewKonteringValues = {
    id: newValuesID,
    DEBET: debet ?? 0,
    KREDIT: kredit ?? 0,
    SORTERINGS_NR: newSortNumber,
    RADTYP: radtypDefault,

    _Associations: {
      Faktura_Ref: fakturaID,
    },
  };
  const isKontodelMomspliktig = isNewSelectedKontodelMomspliktig(
    kodplanID,
    selectedMomskontodelsDefOrdningsNr,
    momsKontodelID ?? '',
    bokfDatum
  );
  const radtyp = getKonteringRadtyp(
    momsHantering,
    registreratMomsBelopp,
    isKontodelMomspliktig
  );

  values.RADTYP = radtyp;

  if (isKontodelMomspliktig) {
    const newAvdragsratt = getAvdragsratt(
      kodplanID,
      selectedMomskontodelsDefOrdningsNr,
      momsKontodelID ?? '',
      bokfDatum,
      radtyp
    );

    const shouldUsePreselectedMomssats =
      preSelectedMomssats && ingMomsSats == null;

    if (shouldUsePreselectedMomssats) {
      const refMomsmallUpdateValue: FormUpdateAssociatonType = {
        associationName: 'IngMoms',
        operation: 'Ref',
        id: preSelectedMomssats.id ?? '',
        values: {
          id: preSelectedMomssats.id ?? '',
        },
      };

      const ingandeMomsBelopp = getIngaendeMoms(
        beloppInklMoms,
        true,
        preSelectedMomssats.MOMS_SATS1,
        newAvdragsratt
      );

      associatedObject.push(refMomsmallUpdateValue);
      values.ING_MOMS_BELOPP = ingandeMomsBelopp;
      values.ING_MOMS_SATS = preSelectedMomssats.MOMS_SATS1;
    } else if (!(radtyp === 5 || radtyp === 6)) {
      const ingandeMomsBelopp = getIngaendeMoms(
        beloppInklMoms,
        true,
        ingMomsSats,
        newAvdragsratt
      );

      values.ING_MOMS_SATS = ingMomsSats;
      values.ING_MOMS_BELOPP = ingandeMomsBelopp;
    }

    const updatedKostandsBeloppValue = getKostnadsBeloppFormValue(
      konteringID ?? '',
      debet,
      kredit,
      setNewBeloppChange,
      radtyp,
      beloppInklMoms,
      beloppExklMoms,
      shouldUsePreselectedMomssats
        ? preSelectedMomssats.MOMS_SATS1
        : ingMomsSats,
      newAvdragsratt,
      null,
      utlMomsSats,
      utlMoms
    );

    values = { ...values, ...updatedKostandsBeloppValue };
    values.MOMSPLIKTIG = isKontodelMomspliktig;
    values.VIKT = isKontodelMomspliktig ? newAvdragsratt : null;
    values.ING_MOMS_MALL = ingMomsMall;
    if (radtyp === 5) {
      values.UTL_MOMS_AVDRAG = getUtlandskAvdrag(
        beloppExklMoms,
        utlMomsSats == null ? utlLevMomsSats : utlMomsSats,
        newAvdragsratt
      );
    }
  } else {
    //Nollställ momsvärden
    values.VIKT = null;
    values.ING_MOMS_MALL = null;
    values.ING_MOMS_SATS = null;
    values.ING_MOMS_BELOPP = null;
    values.MOMSPLIKTIG = false;
    values._Associations.IngMoms_Ref = null;
    values.UTL_MOMS_AVDRAG = null;
  }
  return { values, associatedObject };
};
